// ===== HB CART URL GROUPS =====
// Keeps a multi-URL audit purchase consistent inside the cart page and the
// cart drawer: adding or removing a URL line automatically keeps any
// "applies to all URLs" add-on's quantity equal to the URL count, and prunes
// a "applies to specific URLs" add-on's target list when one of its URLs is
// removed. Relies entirely on data attributes the Liquid templates
// (sections/main-cart-items.liquid, snippets/cart-drawer.liquid) already
// render from the hidden `_hb_*` line-item properties set by hb-custom.js
// when the order was placed — no extra network fetch is needed to read the
// current state, only to write changes back.
//
// Lines are addressed by their stable `item.key` (data-hb-key), never by
// position (data-hb-line). Shopify's /cart/change.js also accepts `line`
// (a 1-based position), but a position shifts the instant any earlier line
// is removed or changes quantity to 0 — including a preceding call in the
// very same reconcile batch. Addressing by key keeps every queued change
// pointed at the correct line regardless of what earlier calls in the batch
// already did to the cart.
document.addEventListener('DOMContentLoaded', function () {
  var ROOT_SELECTOR = '#main-cart-items, #CartDrawer-CartItems';

  function hbCartRoots() {
    return Array.from(document.querySelectorAll(ROOT_SELECTOR));
  }

  function hbNewUrlId() {
    return 'u' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

    function hbNormalizeUrlForCompare(value) {
    var v = String(value || '').trim().toLowerCase();
    if (!v) return '';
    v = v.replace(/^https?:\/\//, '');
    v = v.replace(/^www\./, '');
    v = v.replace(/\/+$/, '');
    return v;
  }

  function hbFetchCartUrlSet() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var set = new Set();
        (cart && cart.items ? cart.items : []).forEach(function (item) {
          var props = item.properties || {};
          Object.keys(props).forEach(function (key) {
            if (/^URL(\s|$)/i.test(String(key).trim())) {
              var normalized = hbNormalizeUrlForCompare(props[key]);
              if (normalized) set.add(normalized);
            }
          });
        });
        return set;
      })
      .catch(function (err) {
        console.error('hb cart fetch error:', err);
        return new Set();
      });
  }

  function hbShowAddUrlError(row, message) {
    var input = row.querySelector('.hb-cart-add-url__input');
    if (input) {
      input.setCustomValidity(message);
      input.reportValidity();
    }
    var err = row.querySelector('.hb-cart-add-url__error');
    if (!err) {
      err = document.createElement('div');
      err.className = 'hb-cart-add-url__error';
      err.setAttribute('role', 'alert');
      err.style.color = '#e5484d';
      err.style.fontSize = '13px';
      err.style.marginTop = '6px';
      err.style.fontWeight = '500';
      row.appendChild(err);
    }
    err.textContent = message;
  }

  function hbClearAddUrlError(row) {
    var input = row.querySelector('.hb-cart-add-url__input');
    if (input) input.setCustomValidity('');
    var err = row.querySelector('.hb-cart-add-url__error');
    if (err) err.remove();
  }



  function hbChangeLine(key, quantity, properties) {
    var body = { id: key, quantity: quantity };
    if (properties) body.properties = properties;
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) { return res.json(); });
  }

  function hbAddLine(item) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) { return res.json(); });
  }

  // Re-render the cart page / drawer contents using the theme's own logic,
  // so our changes show up the same way a normal quantity edit would.
  function hbRefreshCartUI() {
    var els = document.querySelectorAll('cart-items, cart-drawer-items');
    var promises = [];
    els.forEach(function (el) {
      if (typeof el.onCartUpdate === 'function') {
        promises.push(Promise.resolve(el.onCartUpdate()));
      }
    });
    if (!promises.length) {
      // No custom element on this page (shouldn't normally happen on /cart) —
      // fall back to a full reload so the person always sees a correct cart.
      window.location.reload();
      return Promise.resolve();
    }
    return Promise.all(promises);
  }

  // ---- Read current group state straight from the rendered rows ----
  function hbReadGroups(root) {
    var groups = {}; // groupId -> { main: [{key, urlId}], addons: [{key, apply, appliedIds, qty}] }
    root.querySelectorAll('[data-hb-group]').forEach(function (row) {
      var groupId = row.getAttribute('data-hb-group');
      if (!groupId) return;
      var role = row.getAttribute('data-hb-role');
      var key = row.getAttribute('data-hb-key');
      if (!key) return;
      groups[groupId] = groups[groupId] || { main: [], addons: [] };
      if (role === 'main') {
        groups[groupId].main.push({
          key: key,
          urlId: row.getAttribute('data-hb-url-id') || ''
        });
      } else if (role === 'addon') {
        var appliedIds = (row.getAttribute('data-hb-applied-ids') || '')
          .split(',')
          .map(function (s) { return s.trim(); })
          .filter(Boolean);
        groups[groupId].addons.push({
          key: key,
          apply: row.getAttribute('data-hb-apply') || 'all',
          appliedIds: appliedIds,
          qty: parseInt(row.getAttribute('data-hb-qty'), 10) || 0
        });
      }
    });
    return groups;
  }

  // ---- Reconcile add-on quantities/targets to match the URL lines present ----
  // Returns true if any network change was made (caller should refresh the UI).
  function hbReconcile() {
    var changes = []; // { key, quantity, properties? }
    hbCartRoots().forEach(function (root) {
      var groups = hbReadGroups(root);
      Object.keys(groups).forEach(function (groupId) {
        var group = groups[groupId];
        var mainCount = group.main.length;
        var mainUrlIds = group.main.map(function (m) { return m.urlId; }).filter(Boolean);
        group.addons.forEach(function (addon) {
          if (addon.apply === 'all') {
            if (addon.qty !== mainCount) {
              changes.push({ key: addon.key, quantity: mainCount });
            }
          } else {
            var kept = addon.appliedIds.filter(function (id) { return mainUrlIds.indexOf(id) !== -1; });
            if (kept.length !== addon.appliedIds.length || kept.length !== addon.qty) {
              changes.push({
                key: addon.key,
                quantity: kept.length,
                properties: { '_hb_applied_url_ids': kept.join(',') }
              });
            }
          }
        });
      });
    });
    if (!changes.length) return Promise.resolve(false);
    // Applied sequentially (not required for correctness now that each change
    // is addressed by its own stable key, but still avoids firing overlapping
    // writes at Shopify's cart endpoint, which is not documented as safe for
    // concurrent requests against the same cart).
    var chain = Promise.resolve();
    changes.forEach(function (c) {
      chain = chain.then(function () { return hbChangeLine(c.key, c.quantity, c.properties); });
    });
    return chain.then(function () { return true; });
  }

  var hbReconciling = false;
  function hbReconcileAndRefresh() {
    if (hbReconciling) return;
    hbReconciling = true;
    hbReconcile()
      .then(function (changed) {
        if (changed) return hbRefreshCartUI();
      })
      .catch(function (err) { console.error('hb cart reconcile error:', err); })
      .finally(function () { hbReconciling = false; });
  }

  // ---- "+ Add another URL" row (rendered server-side, one per group) ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.hb-cart-add-url__btn');
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('.hb-cart-add-url-row');
    if (!row) return;
          var input = row.querySelector('.hb-cart-add-url__input');
    var url = input ? input.value.trim() : '';
    hbClearAddUrlError(row);
    if (!url) {
      if (input) input.reportValidity ? input.reportValidity() : null;
      return;
    }
    if (input && input.checkValidity && !input.checkValidity()) {
      input.reportValidity();
      return;
    }
    var groupId = row.getAttribute('data-hb-group');
    var variantId = Number(row.getAttribute('data-hb-variant-id'));
    var maxQty = row.getAttribute('data-hb-max-qty');
    var nextIdx = row.getAttribute('data-hb-next-idx') || '1';
    if (!groupId || !variantId) return;

    btn.disabled = true;

    var normalizedNew = hbNormalizeUrlForCompare(url);
    hbFetchCartUrlSet().then(function (cartUrls) {
      if (normalizedNew && cartUrls.has(normalizedNew)) {
        hbShowAddUrlError(row, 'This page is already in your cart for this service — enter a different page.');
        btn.disabled = false;
        return;
      }

      var props = {};
      props['URL ' + nextIdx] = url;
      props['_hb_group'] = groupId;
      props['_hb_role'] = 'main';
      props['_hb_url_id'] = hbNewUrlId();
      if (maxQty) props['_hb_max_qty'] = maxQty;

      hbAddLine({ id: variantId, quantity: 1, properties: props })
        .then(function (response) {
          if (response && response.status) {
            console.error('hb add URL error:', response.description);
            btn.disabled = false;
            return;
          }
          return hbRefreshCartUI().then(hbReconcileAndRefresh);
        })
        .catch(function (err) {
          console.error('hb add URL error:', err);
          btn.disabled = false;
        });
    });
  });

  // Clear the duplicate/validity error as soon as the person edits the URL.
  document.addEventListener('input', function (e) {
    var input = e.target.closest('.hb-cart-add-url__input');
    if (!input) return;
    var row = input.closest('.hb-cart-add-url-row');
    if (row) hbClearAddUrlError(row);
  });

   // Enter key in the add-URL field submits the same way as the button.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('.hb-cart-add-url__input');
    if (!input) return;
    e.preventDefault();
    var row = input.closest('.hb-cart-add-url-row');
    var btn = row ? row.querySelector('.hb-cart-add-url__btn') : null;
    if (btn) btn.click();
  });

  // ---- Reconcile after any cart change (removals, native quantity edits) ----
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && (event.source === 'hb-cart-url-groups')) return;
      hbReconcileAndRefresh();
    });
  }

  // Reconcile once on load too, in case the cart was left in an inconsistent
  // state from before this feature existed, or from a page reload.
  hbReconcileAndRefresh();
});
